/* eslint-disable no-return-await */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
import * as LDClient from 'launchdarkly-js-client-sdk';
import Locale from './Locale';
import Util from './Util';
// eslint-disable-next-line import/no-cycle
import {userInfo} from './userInfo';

const JWT_EXPIRED_BODY = 'Expired JWT token.';
let do_once = true;
const WEB_TIMEOUT_THRESHOLD = 30000; // thirty seconds
const CONTENT_TYPE_JSON = 'application/json;charset=UTF-8';
const CONTENT_TYPE_FORM = 'application/x-www-form-urlencoded;charset=UTF-8';

export function isNonProd(url_) {
    const url = url_ || window.location.hostname;
    return ['localhost', '.local.', '.dev.', '.qa.', '.beta.', '-np.'].some(env => url.includes(env));
}

const LD_CLIENT_KEY = isNonProd() ? '5b96a6ea9619fd15611a534b' : '5b96a6ea9619fd15611a534c';

// dev, qa, beta, live
// Since proxying api requests through f5, want all api calls to be relative to the page url,
// so no hostname by default & no params by default

let testingAsPath = null;
let apiServer = '';

export function getLocaleFromURL(optionalUrl_) {
    const optionalUrl = optionalUrl_ || window.location.search;
    const foundIdx = optionalUrl.indexOf('lang=');
    let locale = null;
    if (foundIdx > -1 && optionalUrl.length - foundIdx >= 10) {
        locale = optionalUrl.substr(foundIdx + 5, 5);
        locale = locale.replace('_', '-');
        if (!/([a-z][a-z]-[A-Z][A-Z])/.test(locale)) {
            // Validate it
            locale = null;
        }
    }
    return locale;
}

export function getViewingAs(optionalUrl_, justPath = false) {
    let optionalUrl = optionalUrl_ || window.location.href;
    const parts = optionalUrl.split('?');
    if (parts.length > 1) {
        optionalUrl = parts[0];
    }
    // eslint-disable-next-line no-useless-escape

    const viewingAs = optionalUrl.match(/\/as\/([^\/]*)\/([^\/\?]*)\/?/); //eslint-disable-line

    if (viewingAs && viewingAs.length > 1) {
        // eslint-disable-next-line no-useless-escape
        const pattern = /^[a-zA-Z0-9-_\.\+\%]+$/; // Can only contains alphanumerics and ._%+-
        for (let i = 1; i < viewingAs.length; i += 1) {
            const value = viewingAs[i];
            if (!pattern.test(value)) {
                return null; // An invalid parameter
            }
        }
        return justPath ? viewingAs[0] : viewingAs;
    }
    return null;
}

// Looks for viewing-as path elements on non-production builds & returns formatted as query params.
// This is only needed when viewing the react app directly rather than in CC7
export function checkViewingAs(optionalUrl) {
    const viewingAs = getViewingAs(optionalUrl);
    if (viewingAs) {
        return `?accountId=${viewingAs[1]}&userId=${viewingAs[2]}`;
    }
    return '';
}

export function getProductionParams() {
    if (userInfo.ddc) {
        return `?accountId=${userInfo.ddc.account.accountId}&userId=${userInfo.ddc.viewingOrActualUser.userId}`;
    }
    return '';
}

function getParameters() {
    let getParams = checkViewingAs(testingAsPath);

    // Non-production builds are using local api directly, not through package proxy which didn't work.
    // In order for this to work, local override for security needs to be enabled before starting
    // cc-configuration-gateway locally. Check readme for running locally for specifics
    if (process.env.NODE_ENV !== 'production') {
        if (import.meta.env.VITE_ML3_HOST) {
            apiServer = import.meta.env.VITE_ML3_HOST;
        } else if (process.env.NODE_ENV === 'development') {
            console.warn('DEVELOPMENT ENVIRONMENT VARIABLE VITE_ML3_HOST IS UNDEFINED'); // eslint-disable-line
        }
    } else if (getParams === '') {
        getParams = getProductionParams();
    }
    return getParams;
}

export function _setViewingAsForUnitTests(asPath) {
    testingAsPath = asPath;
}

export function getLocale() {
    // Note that navigator.languages[0] is used by Accept-Language (https://developer.mozilla.org/en-US/docs/Web/API/NavigatorLanguage/languages)
    // Our api uses standard hyphen; cc uses underscores
    const urlLocale = getLocaleFromURL();
    const curLocale =
        urlLocale ||
        ('ddc' in userInfo && userInfo.ddc.currentLocale.replace('_', '-')) ||
        (navigator.languages && navigator.languages[0]) ||
        navigator.language ||
        navigator.userLanguage;

    // only return supported locales
    return (Locale.exists(curLocale) && curLocale) || 'en-US';
}

export function getLocaleCountry() {
    return getLocale().substr(-2);
}

function isStatusSuccessful(status) {
    return status >= 200 && status < 300;
}

function processRaceResults(response) {
    if (response.message && response.message === 'Request Timeout') {
        return Promise.reject(response);
    }
    return Promise.resolve(response);
}

async function checkResponse(response) {
    if ([401, 403].includes(response.status)) {
        return await response
            .clone()
            .json()
            .then(res => {
                if (res.message === JWT_EXPIRED_BODY) {
                    console.warn('jwt expired', res.message); // eslint-disable-line
                    // NOT NEEDEQD ANYMORE CAUSES CONSTANT RELOAD OF APP! window.location.reload(true); // force full page reload to get new jwt...
                    return Promise.reject('Session Expired.'); // shouldn't get here, but just in case...
                }
                return response;
            })
            .catch(error => {
                if (error && error.message && error.message.toUpperCase().includes('JSON')) {
                    console.warn('JSON error', error.message); // eslint-disable-line
                    return {};
                }
                return error;
            });
    }
    if (!isStatusSuccessful(response.status)) {
        console.warn('not successful', response.status); // eslint-disable-line
        return Promise.reject({message: `Error code ${response.status}`, code: response.status});
    }
    return response;
}

/**
 * Common fetch utility so all special handling done in one place.
 * isJson is superseded by isForm.
 * @param path (String) Endpoint url
 * @param method (String) GET/PUT/POST
 * @param isJson (bool) sets Content-Type to json
 * @param isForm (bool) sets Content-Type to form
 * @param useCurrentDomain (bool) Domain
 * @param body (JSON Object) POST/PUT Contents
 * @param threshold (number) time limit for fetch call, must be greater than 0, undefined, or null
 * @returns {Promise<never>|Promise<*>|Promise<Promise<never> | Promise<*>>}
 */
export function ccFetch(path, method, isJson, isForm, useCurrentDomain, body, threshold = null) {
    const domain = Util.getBoolean(useCurrentDomain) ? '' : apiServer;

    if (!path) {
        return Promise.reject({message: 'No path'});
    }

    const headerParams = {'Accept-Language': getLocale()};
    if (process.env.NODE_ENV !== 'production') {
        if (import.meta.env.VITE_CC7_JWT) {
            headerParams.Authorization = `Bearer ${import.meta.env.VITE_CC7_JWT}`;
            headerParams['X-Cox-Automotive-Client'] = 'ignore-jwt-expiration';
        } else if (process.env.NODE_ENV === 'development' && do_once) {
            do_once = false;
            console.warn('DEVELOPMENT ENVIRONMENT VARIABLE VITE_CC7_JWT IS UNDEFINED'); // eslint-disable-line
        }
    }
    const config = {
        method: method || 'GET',
        headers: headerParams,
        body
    };

    if (isJson) {
        config.headers['Content-Type'] = CONTENT_TYPE_JSON;
    }

    if (isForm) {
        config.headers['Content-Type'] = CONTENT_TYPE_FORM;
    }

    let addParams = getParameters(); // account/user information

    if (path.indexOf('?') !== -1) {
        // don't add account and user params if the path already contains it
        if (path.indexOf('accountId') !== -1 && path.indexOf('userId') !== -1) {
            addParams = '';
        } else {
            addParams = addParams.replace('?', '&');
        }
    }

    const getThreshold = timeout =>
        new Promise(res => {
            setTimeout(() => {
                res(new Error('Request Timeout'));
            }, timeout || WEB_TIMEOUT_THRESHOLD);
        });

    if (config.method === 'POST') {
        const post_threshold = getThreshold(threshold); // must be called outside of the Promise.race
        return Promise.race([
            post_threshold,
            fetch(`${domain}/${path}${addParams}`, config).then(response => checkResponse(response))
        ])
            .then(resp => processRaceResults(resp))
            .then(data => data.json())
            .catch(error => {
                if (error && error.message && error.message.toUpperCase().includes('JSON')) {
                    return {};
                }
                return error;
            });
    }

    // GET, PUT, etc.
    const get_threshold = getThreshold(threshold); // must be called outside of the Promise.race

    // this ensures that we aren't resolving the fetch with a ReadableStream; wait until the data is fully sent
    return fetch(`${domain}/${path}${addParams}`, config).then(response =>
        checkResponse(response).then(data => {
            if (data.ok) {
                const get_json = data.json().catch(error => {
                    if (error && error.message && error.message.toUpperCase().includes('JSON')) {
                        return {};
                    }
                    return error;
                });
                return Promise.race([get_threshold, get_json]).then(resp => processRaceResults(resp));
            }
            return {};
        })
    );
}

export function ccFetchJson(path, onSuccess, onError) {
    return ccFetch(path)
        .then(response => {
            if (!isStatusSuccessful(response.status)) {
                if (onError) {
                    return onError({message: `Error code ${response.status}`});
                }
                return Promise.resolve(response);
            }

            // No JSON returned yet
            return response
                .json()
                .then(onSuccess)
                .catch(errorObj => {
                    let error = errorObj;
                    if (error && error.message && error.message.toUpperCase().includes('JSON')) {
                        error = {};
                    }
                    if (onError) {
                        return onError(error);
                    }
                    return null;
                });
        })
        .catch(error => {
            if (onError) {
                return onError(error);
            }
            return null;
        });
}

export function getUserId() {
    let userId = null;
    const viewingAs = getViewingAs();
    if (viewingAs && viewingAs.length === 3) {
        return viewingAs[2];
    }
    if ('ddc' in userInfo && userInfo.ddc.viewingOrActualUser.userId) {
        userId = userInfo.ddc.viewingOrActualUser.userId;
    }
    return userId;
}

export function getAccountId() {
    let accountId = null;
    const viewingAs = getViewingAs();
    if (viewingAs && viewingAs.length === 3) {
        return viewingAs[1];
    }
    if ('ddc' in userInfo && userInfo.ddc.account.accountId) {
        accountId = userInfo.ddc.account.accountId;
    }
    return accountId;
}

export function getInternalUser() {
    return 'ddc' in userInfo &&
        userInfo.ddc.isInternal &&
        userInfo.ddc.actualUser.internalUserId === userInfo.ddc.actualUser.userId
        ? userInfo.ddc.actualUser.internalUserId
        : null;
}

export function getActualUser() {
    let userId = null;
    if (
        'ddc' in userInfo &&
        userInfo.ddc.isInternal &&
        userInfo.ddc.actualUser.internalUserId === userInfo.ddc.actualUser.userId
    ) {
        userId = userInfo.ddc.actualUser.internalUserId;
    }

    if ('ddc' in userInfo && !userInfo.ddc.isInternal) {
        userId = userInfo.ddc.actualUser.userId;
    }
    return userId;
}

/**
 * Allow multiple LaunchDarkly flags to be read
 * @param flagList (String or String list) LaunchDarkly feature flag name(s)
 * @param defaultList (any or list of any values) default values, if service returns an error
 * @param userId (String) optional target, defaults to DDC userId
 * @returns {Promise(list of flag values)}
 */
export function getFeatureFlags(flagList, defaultList, userId) {
    if (!flagList) {
        return Promise.reject('getFeatureFlags: need at least one LaunchDarkly flag');
    }
    return new Promise((resolve, reject) => {
        const user = {
            key: userId || getUserId()
        };
        if (!user.key) {
            reject('getFeatureFlags: no userId given');
        } else {
            const ld_client = LDClient.initialize(LD_CLIENT_KEY, user);

            ld_client.on('ready', () => {
                const flags = typeof flagList === 'string' ? [flagList] : flagList;

                // eslint-disable-next-line no-nested-ternary
                const defaults = defaultList
                    ? typeof defaultList === 'boolean'
                        ? [defaultList]
                        : flags.map((na, idx) => (idx < defaultList.length ? defaultList[idx] : false)) //eslint-disable-line
                    : flags.map(() => false);

                const flagValues = flags.map((flag, idx) => ld_client.variation(flag, defaults[idx]));
                resolve(flagValues);
            });
        }
    });
}

// Convenience function to request one flag and get back a single value, as opposed to an array of one
export async function getFeatureFlag(flag, defaultValue, userId) {
    let results = false;
    try {
        results = await getFeatureFlags(flag, defaultValue, userId);
    } catch (e) {
        if (process.env.NODE_ENV !== 'test') {
            console.warn(e.message ? e.message : 'getFeatureFlag error'); // eslint-disable-line
        }
    }
    return results.length ? results[0] : results;
}
